var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NavQuestion',{attrs:{"heading":'Advice Page',"background":'bg-desk',"questionOptions":true},scopedSlots:_vm._u([{key:"contents",fn:function(){return undefined},proxy:true},{key:"navButtons",fn:function(){return [_c('NavQuestionButtons',{attrs:{"validated":true,"forwardText":'Share',"forwardLink":'/share'}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }